import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';

import { Button } from '@hotjar/hotsauce';
import { useTippy } from '@hotjar/webapp/hooks/useTippy';

import { Dropdown, List, Item } from './Dropdown';

interface DownloadDropdownProps {
  onDownloadImage: () => void;
  onDownloadData: () => void;
}

export const DownloadDropdown = ({
  onDownloadImage,
  onDownloadData,
}: DownloadDropdownProps): JSX.Element => {
  const { t } = useTranslation('heatmaps');

  const tippyInstance = useTippy();

  const handleDownloadImage = (): void => {
    onDownloadImage();
    tippyInstance.close();
  };

  const handleDownloadData = (): void => {
    onDownloadData();
    tippyInstance.close();
  };

  return (
    <Dropdown
      onCreate={tippyInstance.set}
      trigger={
        <Button
          icon="download"
          kind="ghost"
          size="s"
          css={css`
            text-transform: capitalize;
          `}
        >
          {t('general-terms.download')}
        </Button>
      }
    >
      <List>
        <Item
          title={t('download-actions.download-jpg')}
          subTitle={t('download-actions.download-jpg-subtitle')}
          onClick={handleDownloadImage}
        />
        <Item
          title={t('download-actions.download-csv')}
          subTitle={t('download-actions.download-csv-subtitle')}
          onClick={handleDownloadData}
        />
      </List>
    </Dropdown>
  );
};
